<template>
  <div>
    <div class="row mt-3 mb-5 shadow mx-2 " style="border-radius:20px;">
      <div class="col">
        <div class="row mb-2 mt-3"  v-if="action == 'add_rep'">
          <div class="col-12 pl-2 pl-xl-4">
            <div class="text-muted">{{ repTask.taskName }}</div>
          </div>
        </div>
        <div class="row mb-2 mt-3"  v-else-if="action == 'rep_history_review'">
          <div class="col-9 pl-2 pl-xl-4">
            &nbsp;
          </div>
          <div class="col-3 pr-2 pr-xl-4 text-right">
            <div class="text-muted" v-if="this.action == 'rep_review' || this.action == 'rep_history_review'">{{ computeRepDate }}</div>
          </div>
        </div>
        <div class="row mb-2 mt-3"  v-else>
          <div class="col-9 pl-2 pl-xl-4">
            <div class="text-muted">{{ repTask.taskName }}</div>
          </div>
          <div class="col-3 pr-2 pr-xl-4 text-right">
            <div class="text-muted" v-if="this.action == 'rep_review' || this.action == 'rep_history_review'">{{ computeRepDate }}</div>
          </div>
        </div>

        <div class="row" v-if="alignApproveDenyBtns != 'type4'">
          <div class="text-muted px-2 px-xl-4 mb-2 font-weight-bold">{{ repTask.taskListName }} </div>
        </div>
        <div class="row align-items-end mb-4 col-12" >
          <div class="col-5 px-2 px-xl-4">
            <div class="validate-warning-msg text-center" v-if="verrors.first('subtask_taskIds')">Select minimum one task.</div>
          </div>
        </div>


        <div class="row align-items-end mb-0" v-if="this.action == 'rep_history_review'">
          <div class="col-5 px-2 px-xl-4">
            <p class="small mb-0">Rating</p>

            <div class="btn-group btn-group-toggle rating-btns rep-history" data-toggle="buttons" >
              <label class="btn btn-secondary border-0 rounded mr-2" :class="score == '0' ? 'selected_option' : ''" >
                 0
              </label>
              <label class="btn btn-secondary border-0 rounded mr-2" :class="score == '1' ? 'selected_option' : ''">
                1
              </label>
              <label class="btn btn-secondary border-0 rounded mr-2" :class="score == '2' ? 'selected_option' : ''">
                2
              </label>
              <label class="btn btn-secondary border-0 rounded mr-2" :class="score == '3' ? 'selected_option' : ''">
                3
              </label>
              <label class="btn btn-secondary border-0 rounded mr-2" :class="score == '4' ? 'selected_option' : ''">
                4
              </label>

            </div>
          </div>
          <div class="col-4 px-2 px-xl-4">
            <div class="input-group hours_textbox">
              <fieldset style="background-color: #e9ecef;">
                <legend>Hours</legend>
              
                <div class="input-group-prepend float-left col-4 p-0">
                  <span class="input-group-text bg-white" style="padding: 4px 5px;">
                    <img class="rep_time_icon" :class="clockIconPositionClass" src="@/assets/manager/repetition_time.png" />
                  </span>
                </div>
                <input 
                  type="number" 
                  step="0.1" 
                  min="0" 
                  class="form-control float-left col-7 p-0 text-muted text-right pr-2" 
                  placeholder="" 
                  v-validate="'required'" 
                  name="timeOnTask" 
                  v-model="timeOnTask" 
                  readonly="true"
                  @input.prevent="checkTimeOnTaskInput" style="margin-top: -6px !important; text-align: left !important;  padding-left: 27px !important;" />
              </fieldset>

            </div>
            
          </div>
          <div class="col-3 px-2 px-xl-3 text-right" v-if="alignApproveDenyBtns == 'type1'">
            <a href="#" class="mr-2">Deny</a>
            <a href="#" class="btn btn-primary rounded-pill border-0 text-white approve_btn">Approve</a>
          </div>
        </div>



        <div class="row align-items-end mb-0" v-if="this.action != 'rep_history_review'">
          <div class="col-5 px-2 px-xl-4" v-if="alignApproveDenyBtns != 'type3'">
            <p class="small mb-0">Rating</p>

            <div class="btn-group btn-group-toggle rating-btns" data-toggle="buttons">
              <label class="btn btn-secondary border-0 rounded mr-2" :class="score == '0' ? 'selected_option' : ''" disabled="true">
                <input type="radio" name="score" v-model="score" value="0" v-validate="'required'" data-vv-name="score"> 0
              </label>
              <label class="btn btn-secondary border-0 rounded mr-2" :class="score == '1' ? 'selected_option' : ''">
                <input type="radio" name="score" v-model="score" value="1" v-validate="'required'" data-vv-name="score"> 1
              </label>
              <label class="btn btn-secondary border-0 rounded mr-2" :class="score == '2' ? 'selected_option' : ''">
                <input type="radio" name="score" v-model="score" value="2" v-validate="'required'" data-vv-name="score"> 2
              </label>
              <label class="btn btn-secondary border-0 rounded mr-2" :class="score == '3' ? 'selected_option' : ''">
                <input type="radio" name="score" v-model="score" value="3" v-validate="'required'" data-vv-name="score"> 3
              </label>
              <label class="btn btn-secondary border-0 rounded mr-2" :class="score == '4' ? 'selected_option' : ''">
                <input type="radio" name="score" v-model="score" value="4" v-validate="'required'" data-vv-name="score"> 4
              </label>
            </div>
            
          </div>
          <div class="col-4 px-2 px-xl-4">
            <div class="input-group hours_textbox">
              <fieldset>
                <legend>Hours</legend>
              
                <div class="input-group-prepend float-left col-4 p-0">
                  <span class="input-group-text bg-white" style="padding: 4px 5px;">
                    <img class="rep_time_icon" :class="clockIconPositionClass" src="@/assets/manager/repetition_time.png" />
                  </span>
                </div>
                <input 
                  type="number" 
                  step="0.1" 
                  min="0" 
                  class="form-control float-left col-7 p-0 text-muted text-right pr-2" 
                  placeholder="" 
                  v-validate="'required'" 
                  name="timeOnTask" 
                  v-model="timeOnTask" 
                  @input.prevent="checkTimeOnTaskInput" 
                  @input.blur="checkfloatCount"
                  style="margin-top: -6px !important; text-align: left !important;  padding-left: 27px !important;" />
              </fieldset>
            </div>
            
          </div>
          <div class="col-5 px-2 px-xl-4" v-if="alignApproveDenyBtns == 'type3'">
            &nbsp;
          </div>
          <div class="col-3 px-2 px-xl-2 text-right" v-if="alignApproveDenyBtns == 'type3'">
            <a href="#" class="btn btn-primary rounded-pill border-0 text-white approve_btn d-block w-75 ml-auto" :class="{disabled: submitDone}" @click.prevent="handleAddRep">Add Rep</a>
          </div>
        </div>

        <div class="row align-items-end mb-4">
          <div class="col-4 px-2 px-xl-4">
            <div class="validate-warning-msg text-center" v-if="verrors.first('timeOnTask')">Hours is required</div>
          </div>
          <div class="col-3 px-2 px-xl-4"></div>
        </div>

        <div class="row">
          <div class="col-12 px-2 px-xl-4 mb-4" v-if="action == 'rep_review'">
            <div class="text-muted font-weight-bold">{{ menteeFirstName }}</div>
            <div class="row mb-3">
              <div class="col-11 pr-0">
                <div class="text-muted" v-if="repTask.menteeComment">{{ repTask.menteeComment }}</div>
                <div class="text-muted" v-else>No comment.</div>
              </div>
              <div class="col-1 px-0 px-xl-2">
                <a href="#" @click.prevent="toggleRepReplyBox"><img class="rep_reply_icon mr-2" src="@/assets/manager/comment_reply_icon.png" /></a>
              </div>
            </div>
            <div class="row align-items-end" v-if="showRepReplyBox">
              <div class="col-10 pr-0 col-xl-11 pr-xl-1">
                <textarea name="" rows="3" :placeholder="'Reply to ' + menteeShortName" class="form-control text-muted" maxLength="180" v-model="comments"></textarea>
              </div>
              <div class="col-2 pl-0 pr-3 col-xl-1 px-xl-0 text-right text-muted">
                {{ this.comments.length }}/{{ this.characterLimit }}
              </div>
            </div>
          </div>

          <div class="col-12 px-2 px-xl-4 mb-4" v-if="action == 'add_rep'">
            <div class="row mb-3">
              <div class="col-11 pr-0">
                <div class="text-muted font-weight-bold" @click.prevent="toggleRepReplyBox" style="cursor: pointer;">Add Comment</div>
              </div>
              <div class="col-1 px-0 px-xl-2">
                <a href="#" @click.prevent="toggleRepReplyBox"><img class="rep_reply_icon mr-2" src="@/assets/manager/comment_reply_icon.png" /></a>
              </div>
            </div>
            <div class="row align-items-end" v-if="showRepReplyBox">
              <div class="col-10 pr-0 col-xl-11 pr-xl-1">
                <textarea name="" rows="3" :placeholder="'Comment to ' + menteeShortName" class="form-control text-muted" maxLength="180" v-model="comments"></textarea>
              </div>
              <div class="col-2 pl-0 pr-3 col-xl-1 px-xl-0 text-right text-muted">
                {{ this.comments.length }}/{{ this.characterLimit }}
              </div>
            </div>
          </div>

          <div class="col-12 px-2 px-xl-4 mb-4" v-if="action == 'rep_history_review'">
            <div class="text-muted font-weight-bold">{{ menteeFirstName }}</div>
            <div class="row mb-3">
              <div class="col-11 pr-0">
                <div class="text-muted" v-if="repTask.menteeComment">{{ repTask.menteeComment }}</div>
                <div class="text-muted" v-else>No comment.</div>
              </div>
              <div class="col-1 px-0 px-xl-2">
                <a href="#" @click.prevent="toggleRepReplyBox"><img class="rep_reply_icon mr-2" src="@/assets/manager/comment_reply_icon.png" /></a>
              </div>
            </div>
            <div class="row align-items-end" v-if="showRepReplyBox">
              <div class="col-10 pr-0 col-xl-11 pr-xl-1">
                <textarea name="" rows="3" :placeholder="'Reply to ' + menteeShortName" class="form-control text-muted" maxLength="180" readonly="true" v-model="comments"></textarea>
              </div>
              <div class="col-2 pl-0 pr-3 col-xl-1 px-xl-0 text-right text-muted">
                {{ this.comments.length }}/{{ this.characterLimit }}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import { formatRepTime, calcRepTime, formatRepDate } from '@/components/shared/utils.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: {
    alignApproveDenyBtns: {
      type: String,
      default: 'type1',
    },
    clockIconPositionClass: {
      type: String,
      default: '',
    },
    menteeId: {
      type: [Number, String],
      default: 0,
    },
    menteeFirstName: {
      type: String,
      default: '',
    },
    menteeShortName: {
      type: String,
      default: '',
    },
    repTask: {
      type: Object,
      default: {},
    },
    action: {
      type: String,
      default: 'rep_review',
    },
    isSectionInAdd: {
      type: String,
      default: 'no',
    },
  },
  data() {
    return {
      showRepReplyBox: false,
      score: this.repTask.score !== undefined  ? this.repTask.score : null,
      comments: this.repTask.comment ? this.repTask.comment : '',
      timeOnTask: this.repTask.minutes ? formatRepTime(this.repTask.minutes) : '',
      characterLimit: 180,
      isSection: (!this.repTask.taskId ? true : false),
      showSubTasks: false,
      selectedTasks: 0,
      selectedSubTasks:[],
      subtask_taskIds: [],
      submitDone: false,
    }
  },
  methods: {
    checkIsSection() {
      if (this.action == 'add_rep') {
        if(this.isSectionInAdd == 'yes') {
          this.isSection = true;
        } else {
          this.isSection = false;
        }
      }
    },
    checkfloatCount() {
      var decimalCount = this.timeOnTask.toString().split(".")[1].length;
      if(decimalCount > 1) {
        alert("Time should contain single decimal value");
        var val = this.timeOnTask;
        this.timeOnTask = parseFloat(val).toFixed(1);
        return false;
      }
    },
    timeOnTaskInput(ev) {
      let value = ev.target.value;
      let valueRevised = parseFloat(value).toFixed(2);
      let valueRevisedParts = valueRevised.toString().split('.');      
      let minutes = valueRevisedParts[1] || undefined;
      
      if (minutes !== undefined && minutes > 59) {
        if (minutes == 99) {
          let hours = parseInt(valueRevisedParts[0]);

          if (hours > 1) {
            hours = hours - 1;
          }

          let newValue = hours + '.59';
          this.timeOnTask = newValue;
        } else {
          let newValue = (parseInt(valueRevisedParts[0]) + 1) + '.' + parseInt((minutes - 60), 10);
          this.timeOnTask = newValue;
        }        
      }
    },
    changeSelectedSubTasks(taskId, event) {
      if(event.target.checked == true) {
        this.selectedSubTasks.push({
          id: taskId,
        });
      }
      else {
        for(var i=0; i<this.selectedSubTasks.length; i++) {
          if(this.selectedSubTasks[i].id == taskId) {
            this.selectedSubTasks.splice(i, 1);
          }
        }
      }
    },
    toggleShowSubTasks() {
      this.showSubTasks = !this.showSubTasks;
    },
    toggleRepReplyBox(event) {
      this.showRepReplyBox = !this.showRepReplyBox;
    },
    doValidateAddRep() {
      var flag = 0;
      if((this.timeOnTask == '0.0') || (this.timeOnTask == 0)) {
          alert("Time should be greater than zero");
          flag = 1;
      }
      return flag;
    },
    handleAddRep() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        var flag = this.doValidateAddRep();
        if(flag == 0) {
          this.submitDone = true;
          var decimalCount = this.timeOnTask.toString().split(".")[1].length;
          if(decimalCount > 1) {
            alert("Time should contain single decimal value");
            var val = this.timeOnTask;
            this.timeOnTask = parseFloat(val).toFixed(1);
          }
          axios('/mobile/menteerepetition', {
            method: 'POST',
            data: {
              comment: this.comments,
              time_on_task: calcRepTime(this.timeOnTask),
              mentee_id: this.menteeId,
              task_id: this.repTask.taskId ? this.repTask.taskId : '',
              tasklist_id: this.repTask.taskListId,
              subtask: this.repTask.subtask_id,
              account_id: this.$store.state.user_accountid,
              selectedSubTasks: this.selectedSubTasks,
            },
          }).then(() => {
            this.submitDone = false;
            this.$validator.reset();
            this.score = null;
            this.comments = '';
            this.toggleShowSubTasks();
            this.toggleRepReplyBox();
            this.selectedSubTasks = [];
            this.subtask_taskIds = [];
            this.timeOnTask = ''
            this.$emit('closeMenteeAddRepModal', 1);
          }).catch(() => {
            this.submitDone = false;
          });
        }
      }).catch(() => {});      
    },
    resetRepForm() {
      this.$validator.reset();
      this.score = null;
      this.comments = '';
      this.selectedSubTasks = [];
      this.subtask_taskIds = [];
      this.timeOnTask = '';
      this.showRepReplyBox = false;
    }
  },
  computed: {
    computeRepDate() {
      return formatRepDate(this.repTask.createdAt);
    },
  },
}
</script>

<style scoped>
.rating-btns button,
.rating-btns label
 {
  background-color: #bfeafb;
}
.rating-btns button:focus, 
.rating-btns button:hover, 
.rating-btns button.selected_btn,
.rating-btns label:focus,
.rating-btns label:hover,
.rating-btns label.selected_option {
  border: 0;
  box-shadow: none !important;
}
.rep-history button:focus, 
.rep-history button:hover, 
.rep-history label:focus,
.rep-history button.selected_btn, 
.rep-history label:hover,
.rep-history label.selected_option
{
  border: 0;
  //background-color: #bfeafb !important;
  box-shadow: none !important;
}

@media (max-width: 1199.98px) {
  .rating-btns button {
    padding: 4px 8px;
  }
}
.search_tasks_txtbox input {
  height: 30px;
  border-right: 0;
  width: 125px !important;
  font-size: 12px;
  border-radius: 10px;
}
.hours_overtext {
  position: absolute;
  top: -22%;
  left: 20%;
  z-index: 4;
}
input:focus, select:focus, textarea:focus, button:focus {
  border-color: #ced4da;
}
.hours_textbox span {
  border: 0;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}
.hours_textbox input {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border: 0;
}
@media (max-width: 1199.98px) {
  .hours_textbox span {
    padding: 6px;
  }
}
.rep_reply_icon {
  /* transform: scaleY(-1); */
  width: 14px;
}
.clock-icon-position-middle {
  position: absolute;
  transform: translateX(-50%);
  left: 0;
  background-color: white;
}
.delete-rep-link {
  color: #F16733;
}
.rep_time_icon {
  width: 15px;
}
fieldset {
  border: 1px solid #ced4da;
  border-radius: 10px;
}
legend {
  color: #002F42;
  font-size: 14px;
  padding-left: 5px;
  margin-bottom: 1px;
  width: 50px;
  margin-left: 15px;
}
textarea {
  background-color: #F0F0F0;
}

</style>


// WEBPACK FOOTER //
// src/components/mentee/mentee_rep_review.vue